import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: [33, 15, 44],
      width: 286,
      [theme.breakpoints.up("mobile")]: {
        width: 572,
        padding: [66, 50, 88],
      },
    },
    title: {
      marginBottom: 26,
      [theme.breakpoints.up("mobile")]: {
        marginBottom: 52,
      },
    },
    divider: {
      width: 63,
      marginBottom: 20,
      height: 2,
      backgroundColor: theme.palette.primary.main,
      [theme.breakpoints.up("mobile")]: {
        width: 126,
        marginBottom: 40,
      },
    },
    description: {
      [theme.breakpoints.up("mobile")]: {
        fontSize: theme.typography.large.fontSize,
      },
    },
  }),
  { name: "ShareModal-EmailForm-Success" },
);
